export const InsuranceIcon = () => `
  <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.18182L14 0L28 6.18182V15.4545C28 24.0318 22.0267 32.0527 14 34C5.97333 32.0527 0 24.0318 0 15.4545V6.18182ZM4.66667 18.5455L10.8889 24.7273L23.3333 12.3636L21.14 10.1691L10.8889 20.3536L6.86 16.3664L4.66667 18.5455Z" fill="#12B829"/>
  </svg>
`